// extracted by mini-css-extract-plugin
module.exports = {"color-checkbox":"ColorCheckbox_color-checkbox__33dv0"};